import { Box, Text } from '@wix/design-system';
import React from 'react';
import s from './MarketingItemRow.scss';
import { FeatureIcon } from './ProductFeatureIcon';
import classNames from 'classnames';
export function MarketingItemRow({ item, zIndex, boxShadow, paddingBottom, paddingTop = 'SP4', className, disabled = false, maxWidth = '200px', }) {
    const { text, prefixIconUrl, suffixIconUrl } = item;
    return (React.createElement(Box, { gap: "SP1", padding: `${paddingTop} 0 ${paddingBottom} 0`, zIndex: zIndex, boxShadow: boxShadow, className: className },
        React.createElement(Box, { width: "85%", maxWidth: maxWidth, margin: "0 auto", direction: "horizontal", align: "left", gap: "4px" },
            prefixIconUrl && (React.createElement(FeatureIcon, { iconUrl: prefixIconUrl, disabled: disabled })),
            React.createElement(Text, { size: "small", className: classNames(s.text, { [s.disabled]: disabled }) },
                text,
                suffixIconUrl && (React.createElement(FeatureIcon, { marginLeft: '3px', iconUrl: suffixIconUrl, disabled: disabled }))))));
}
//# sourceMappingURL=MarketingItemRow.js.map